<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>历史流程</el-breadcrumb-item>
      <el-breadcrumb-item>流程列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
        class="flex-item search-form"
        size="mini"
        :inline="true"
        :model="searchForm"
        style="text-align: left; margin-top: 15px"
    >
      <el-form-item label="搜索词:">
        <el-input v-model="searchForm.keyword" clearable placeholder="请输入商户名称/信用代码/门店名称/门店编号" style="width:280px"/>
      </el-form-item>
      <el-form-item label="所属渠道:" v-if="userRole === '4'">
        <el-select
            v-model="searchForm.channelId"
            placeholder="请选择渠道"
            clearable
            filterable
            style="width: 280px"
        >
          <el-option
              v-for="item in channelList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申报类型:">
        <el-select v-model="searchForm.wfType" placeholder="请选择" clearable style="width:140px">
          <el-option value="1" label="渠道遴选" />
          <el-option value="2" label="新增商户/门店" />
          <el-option value="4" label="修改商户/门店" />
          <el-option value="3" label="退出商户/门店" />
          <el-option value="5" label="渠道退出" />
          <el-option value="6" label="支付业务许可证" />
        </el-select>
      </el-form-item>
      <el-form-item label="审批状态:">
        <el-select v-model="searchForm.wfState" placeholder="请选择" clearable style="width:140px">
          <el-option v-for="item in wfStateList" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间:">
        <el-date-picker
          v-model="searchForm.startDate"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          style="width:130px"
          :picker-options="pickerOptions"
          :default-value="defaultValue"
        />
        <span style="margin:0 4px;color:#909399">—</span>
        <el-date-picker
          v-model="searchForm.endDate"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width:130px"
          :picker-options="pickerOptions"
          :default-value="defaultValue"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="flex-item table-page">
      <el-table
          ref="multipleTable"
          v-loading="tableLoading"
          size="small"
          border
          :data="tableData"
          :height="tableHeight"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="55px" />
        <el-table-column type="index" align="center" width="60px" label="序号" />
        <el-table-column prop="channelName" align="left" min-width="140px" label="渠道名称" show-overflow-tooltip />
        <el-table-column prop="wfType" align="center" min-width="100px" label="申报类型">
          <template slot-scope="scope">
            <span>{{ getWfTypeText(scope.row.wfType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" align="center" min-width="100px" label="审批状态">
          <template slot-scope="scope">
            <span>{{ getWfStateText(scope.row.state) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" min-width="100px" label="创建时间" />
        <el-table-column label="操作" align="center" min-width="100px" fixed="right">
          <template slot-scope="scope">
            <el-button @click.native.prevent="viewWorkflow(scope.row)" type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            :key="paginationKey"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="支付业务许可证"
        :visible.sync="dialogPayVisible"
        width="30%"
        :close-on-click-modal="false"
    >
      <el-form  label-width="150px" >
        <el-row>
          <el-col :span="24">
            <el-upload
                class="upload-demo"
                :action="uploadUrl"
                :before-upload="beforeUpload"
                :on-success="handleSuccess"
                :on-error="handleError"
                :show-file-list="true"
                :file-list="fileList"
                accept=".pdf"
                :limit= "1"
                :on-remove="handleRemove"
            >
              <el-button size="mini" type="primary">上传文件</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <br/>
        <div class="flex-item" style="text-align: right;">
          <el-button size="small" type="primary" @click="submit()">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { historyPageQuery, template, getTerm, getWorkflowById, getIsUploadPayBusinessLicense } from "@/api/system/workflow/workflow";
import { saveWorkflowInfo, deleteFileById } from "@/api/system/linXuanChannel/linXuanChannel";
import * as util from "@/assets/js/util";
import axios from "axios";
import {SYS_APi_SCREENING_URL} from "@/utils/globals";
import { channelDict } from "@/api/system/channel";

const wfTypeMap = { '1': '渠道遴选', '2': '新增商户/门店', '4': '修改商户/门店', '3': '退出商户/门店', '5': '渠道退出', '6': '支付业务许可证' };
const stateMap = {
  'draft': '待提交', 'reviewing': '审核中', 'completed': '审核完成'
};
const stateColorMap = {
  'draft': '#909399', 'reviewing': '#FFA940', 'completed': '#53ff40'
};

const wfStateList = [
  { value: 'draft', label: '待提交' },
  { value: 'reviewing', label: '审核中' },
  { value: 'completed', label: '审核完成' }
];

export default {
  name: "workflowList",
  data() {
    return {
      fileId: '',
      channelList: [],
      uploadLoading: null,
      chunkSize: 9 * 1024 * 1024, // 每个块的大小，5MB
      fileList: [],
      uploadUrl: '/file/uploadChunk',
      channelId: '',
      isUploadPayLicense: false,
      dialogPayVisible: false,
      tableLoading: false,
      tableData: [],
      tableHeight: 400,
      paginationKey: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      multipleSelection: [],
      userRole: '',
      isShowCDbut: true,
      isShowMerchantBut: false,
      term: { isInRange: true, info: '' },
      searchForm: { keyword: '', channelId: '', wfType: '', wfState: '', startDate: '', endDate: '' },
      wfStateList: wfStateList
    };
  },
  created() {
    this.userRole = util.session("userRole") && util.session("userRole").userRole || '';
    if (this.userRole === "2" || this.userRole === "3") {
      this.isShowCDbut = false;
    }
    this.isShowMerchantBut = this.userRole === "1";
    // 加载渠道下拉字典，完成后从路由 query 恢复搜索条件再查询
    channelDict().then(res => {
      if (res && res.code === '200') {
        this.channelList = res.data || [];
      }
    })
    // 从路由 query 恢复搜索条件（返回列表时保留）
    const query = this.$route.query
    if (query.keyword)      this.searchForm.keyword    = query.keyword || ''
    if (query.wfType)       this.searchForm.wfType     = query.wfType || ''
    if (query.wfState)      this.searchForm.wfState    = query.wfState || ''
    if (query.startDate)    this.searchForm.startDate  = query.startDate || ''
    if (query.endDate)      this.searchForm.endDate    = query.endDate || ''
    if (query.channelId)    this.searchForm.channelId  = query.channelId || ''
    if (query.hasOwnProperty('currentPage'))  this.currentPage = parseInt(query.currentPage) || 1
    if (query.hasOwnProperty('pageSize'))     this.pageSize    = parseInt(query.pageSize)    || 10
    this.findTerm();
    this.fetchList();
    this.fetchIsUploadPayLicense();
  },
  computed: {
    defaultValue() {
      const now = new Date();
      // 上个月的今天（月份-1）
      return new Date(now.getFullYear(), now.getMonth() - 1, 1);
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          // 获取当前时间
          const now = new Date();
          // 获取本年本月的第一天 00:00:00
          const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);

          // 如果待选日期的时间戳 大于等于 本月第一天的时间戳，则禁用
          return time.getTime() >= firstDayOfCurrentMonth.getTime();
        }
      };
    }
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener('resize', this.setTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight);
  },
  methods: {
    fetchIsUploadPayLicense() {
      getIsUploadPayBusinessLicense().then(res => {
        if (res && res.code === '200' && res.data) {
          this.isUploadPayLicense = res.data.flag || false;
          this.channelId = res.data.channelId || '';
          this.saleModel = res.data.saleModel || '';
        }
      }).catch(() => {
        this.isUploadPayLicense = false;
      });
    },
    fetchList() {
      this.tableLoading = true;
      historyPageQuery({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchForm.keyword,
        dataType: this.searchForm.wfType,
        status: this.searchForm.wfState,
        startTime: this.searchForm.startDate,
        endTime: this.searchForm.endDate,
        userRole: this.userRole,
        channelId: this.searchForm.channelId
      }).then(res => {
        if (res && res.code === '200') {
          if(this.userRole === '1' && res.data!= null && res.data.records!= null && res.data.records.length > 0){
            this.isShowCDbut = false;
          }
          this.total = res.data.total || 0;
          this.paginationKey = `${this.currentPage}-${this.pageSize}-${this.total}`;
          this.tableData = (res.data.records || []).map(item => ({
            ...item,
            id: item.id || item.parentId
          }));
        } else {
          this.$message.error(res && res.message ? res.message : '查询失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(() => {
        this.$message.error('查询失败，请稍后重试');
        this.tableData = [];
        this.total = 0;
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    onReset() {
      this.searchForm = { keyword: '', wfType: '', wfState: '', startDate: '', endDate: '' };
      this.onSearch();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getWfTypeText(type) { return wfTypeMap[type] || '-'; },
    getWfStateText(state) { return stateMap[state] || '-'; },
    getWfStateColor(state) { return stateColorMap[state] || '#333'; },
    viewWorkflow(row) {
      this.$router.push({
        path: '/sys/workflowHistory/view/' + (row.parentId || row.id),
        query: {
          keyword: this.searchForm.keyword || '',
          wfType: this.searchForm.wfType || '',
          wfState: this.searchForm.wfState || '',
          startDate: this.searchForm.startDate || '',
          endDate: this.searchForm.endDate || '',
          channelId: this.searchForm.channelId || '',
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      });
    },
    handleEdit(row) {
      getWorkflowById({ flowId: row.id }).then(res => {
        if (res && res.code === '200' && res.data) {
          // 1-渠道申请，2/3/4-商户/门店相关
          const dialogPath = row.wfType === '1' ? 'channelDialog' : 'merchantDialog';
          const channelId = (res.data && res.data.workflow && res.data.workflow.channelId) || row.channelId || '';
          this.$router.push({
            path: '/sys/workflow/' + dialogPath + '/' + row.wfType + '/1/all/',
            query: { flowId: row.id, channelId: channelId }
          });
        }
      });
    },
    handleSubmit(row) {
      this.$confirm('确定要提交该流程吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        saveWorkflowInfo({
          wfType: row.wfType,
          fileId: row.fileId,
          wfState: '1',
          channelInfo: row,
          flowId: row.id,
          parentId: row.parentId
        }).then(res => {
          if (res && res.code === '200') {
            this.$message({ type: 'success', message: '提交成功!' });
            this.fetchList();
          } else {
            this.$message.error(res && res.message ? res.message : '提交失败');
          }
        }).catch(() => {
          this.$message.error('提交失败，请稍后重试');
        });
      }).catch(() => {});
    },
    handleDelete(row) {
      this.$confirm('确定要删除该流程吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        this.$message({ type: 'success', message: '删除成功!' });
        this.fetchList();
      }).catch(() => {});
    },
    findTerm() {
      getTerm({}).then(res => {
        if (res && res.code === '200' && res.data) {
          this.term = res.data;
        }
      });
    },
    channelDeclare() {
      if (this.userRole === '1' && this.term.isInRange === false) {
        this.$message.error(this.term.info);
        return;
      }
      this.$router.push('/sys/workflow/channelDialog/1/1/all/');
    },
    addMerchant(wfType) {
      if (this.userRole === '1' && this.term.isInRange === false) {
        this.$message.error(this.term.info);
        return;
      }
      this.$router.push('/sys/workflow/merchantDialog/' + wfType + '/1/all/');
    },
    uploadChannelPay(){
      if(this.userRole === "1" && this.term.isInRange === false){
        this.$message.error(this.term.info);
        return;
      }
      this.dialogPayVisible = true;
    },
    handleExport() {
      this.$message({ type: 'success', message: '导出任务已提交，请稍后在下载中心查看' });
    },
    downloadTemplate() {
      const loading = this.$loading({
        lock: true,
        text: '正在下载...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      template({}).then(res => {
        loading.close();
        let blob = new Blob([res]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.download = '遴选模板.zip';
        a.click();
        window.URL.revokeObjectURL(url);
        this.$message({ type: 'success', message: '下载成功' });
      }).catch(() => {
        loading.close();
        this.$message.error('下载失败');
      });
    },
    setTableHeight() {
      this.$nextTick(() => {
        if (typeof window !== 'undefined') {
          const clientHeight = window.innerHeight || document.documentElement.clientHeight;
          this.tableHeight = Math.round(clientHeight * 0.58) - 140;
        }
      });
    },

    submit() {
      // 校验是否已上传文件
      if (!this.fileId) {
        this.$message.warning('请先上传支付业务许可证');
        return;
      }
      saveWorkflowInfo({
        fileId: this.fileId,
        channelInfo: { id: this.channelId },
        flag: "1"
      }).then((res) => {
        if (res.code === '200') {
          this.$message({
            type: "success",
            message: "提交成功!",
          });
          // 关闭弹窗
          this.dialogPayVisible = false;
          // 隐藏上传按钮
          this.isUploadPayLicense = false;
          // 刷新列表
          this.fetchList();
        } else {
          this.$message({
            type: "error",
            message: res.message || "提交失败",
          });
        }
      }).catch((error) => {
        this.$message({
          type: "error",
          message: "提交失败：" + (error.message || "未知错误"),
        });
      });
    },
    // 上传每个文件块
    uploadChunk(formData) {
      return new Promise((resolve, reject) => {
        axios.post(SYS_APi_SCREENING_URL + this.uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
            .then(response => {
              resolve(response);  // 返回响应给调用者
            }).catch(error => {
          console.error('请求失败:', error);
          reject(error);
        });
      });
    },
    handleSuccess(response, file, fileList) {
      try {
        const fileId = response.data.data;
        this.fileId = fileId;
        console.log('文件ID:', fileId);
        this.fileList.push({
          name: file.name,
          url: `${SYS_APi_SCREENING_URL}/file/download/${fileId}`,
        });
      } catch (err) {
        this.fileId = "";
        console.error('处理上传响应失败:', err);
      }
    },
    handleError(error, file, fileList) {
      this.fileId = "";
      console.log('上传失败', error);
    },
    closeLoading() {
      if (this.uploadLoading) {
        this.uploadLoading.close();
        this.uploadLoading = null;
      }
    },
    handleRemove(file, fileList) {
      if(this.fileId==""){
        const fileId = this.fileId;
        if (fileId) {
          deleteFileById({fileId: fileId}).then((res) => {
            if (res.code == 200) {
              this.fileList = fileList.filter(item => item.name !== file.name);
              this.$message({
                type: "success",
                message: "上传删除成功!",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }else{
        this.fileList=[];
      }
    },
    // 在文件上传之前拆分成多个块
    beforeUpload(file) {
      const lastDotIndex = file.name.lastIndexOf('.');
      if(lastDotIndex>0){
        let fileName=file.name.substring(0, lastDotIndex)
        if (fileName!=='支付业务许可证') {
          this.$message.error(`只允许上传文件名为支付业务许可证！`);
          return false;
        }
        this.uploadLoading = this.$loading({
          lock: true,
          text: '文件上传中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.chunkedUpload(file);
      } else {
        return false;
      }
    },
    // 分块上传
    async chunkedUpload(file) {
      const uploadId = Date.now()
      const totalChunks = Math.ceil(file.size / this.chunkSize);  // 计算总块数
      let start = 0;
      let end = this.chunkSize;
      let chunkIndex = 0;

      // 上传每个块
      while (start < file.size) {
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('fileName', file.name);
        formData.append('uploadType', 'channel_update');
        formData.append('uploadId', uploadId);
        formData.append('chunkIndex', chunkIndex); // 当前块的索引
        formData.append('totalChunks', totalChunks); // 总块数

        try {
          const response = await this.uploadChunk(formData); // 上传当前块
          if (chunkIndex === totalChunks - 1) {
            // 如果是最后一块，上传完成后显示信息
            this.handleSuccess(response, file, this.fileList);
            this.$message.success('文件上传完成');
            this.closeLoading();
          }
          start = end;
          end = Math.min(end + this.chunkSize, file.size);
          chunkIndex++;
        } catch (err) {
          this.$message.error('文件上传失败');
          this.closeLoading();
          return;
        }
      }
    }
  }
};
</script>

<style scoped>
.flex-container { height: 100%; display: flex; flex-direction: column; }
.flex-item { flex-shrink: 0; }
.flex-item:nth-child(3) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.table-page {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.pagination {
  text-align: right;
  margin-top: 12px;
  flex-shrink: 0;
}
</style>
